module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--jawn"
  }, [_c('div', {
    staticClass: "spinner-inner",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "jawn",
    style: (_vm.innerStyles)
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ea52e40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Jawn.vue
// module id = 637
// module chunks = 1